import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TranslateLoader,
  TranslateModule,
  provideTranslateService,
} from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';

const loaderConfig: Provider = {
  provide: TRANSLATE_HTTP_LOADER_CONFIG,
  useValue: {
    prefix: '/assets/i18n/',
    suffix: '.json',
    useHttpBackend: true,
  },
};

const loaderProvider: Provider = {
  provide: TranslateLoader,
  useClass: TranslateHttpLoader,
};

@NgModule({
  declarations: [],
  imports: [CommonModule, TranslateModule],
  exports: [TranslateModule],
})
export class LocalizationModule {
  static forRoot(): ModuleWithProviders<LocalizationModule> {
    return {
      ngModule: LocalizationModule,
      providers: [
        loaderConfig,
        ...provideTranslateService({
          lang: 'en-US',
          fallbackLang: 'en-US',
          loader: loaderProvider,
        }),
      ],
    };
  }
}
